import { MomentFake } from '@evidia/shared';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import './customAntdStyles.css';

type Props = any & { onChange: (value: Date) => void };

export const CustomTimePicker: React.FC<Props> = props => {
	const { onChange, value } = props;

	return (
		<DatePicker.TimePicker
			{...props}
			onChange={(v: MomentFake) => {
				onChange(v?.toDate());
			}}
			popupClassName="time-picker-popup"
			value={value ? dayjs(value) : undefined}
			needConfirm={false}
		/>
	);
};
